/**
 * T9 - M1 static transparency page (/transparency-m1).
 *
 * Per spec: model card per Luat AI 2026 Dieu 28 + ND 53/2022 retention.
 * Static content (no API dependency) for M1 launch readiness.
 *
 * Note: `transparency.tsx` (existing) renders dynamic model card from
 * /api/v1/public/transparency for the full product. This M1 variant is
 * the static fallback shown until that endpoint is wired Day-1.
 */

export function TransparencyM1Route() {
  return (
    <main
      style={{
        maxWidth: 760,
        margin: '0 auto',
        padding: '32px 16px',
        fontFamily: 'Inter, system-ui, sans-serif',
        lineHeight: 1.7,
        color: '#0f172a',
      }}
    >
      <h1
        style={{
          fontFamily: '"Source Serif Pro", Georgia, serif',
          color: '#1B3B6F',
          fontSize: 28,
          marginBottom: 8,
        }}
      >
        Asklaw AI - Trang minh bach (Transparency)
      </h1>
      <p style={{ color: '#64748b', fontSize: 13, marginTop: 0 }}>
        Cap nhat lan cuoi: 2026-05-11
      </p>

      <section aria-labelledby="model-card-title">
        <h2 id="model-card-title" style={{ color: '#1B3B6F' }}>
          Model card
        </h2>
        <ul>
          <li>Ten he thong: Asklaw AI</li>
          <li>Phien ban: M1 (ra mat 2026-05-11)</li>
          <li>Mo hinh ngon ngu: gemini-3.1-flash-lite (Google)</li>
          <li>Pham vi: tham khao thong tin phap luat Viet Nam</li>
          <li>KHONG phai dich vu tu van phap ly</li>
        </ul>
      </section>

      <section aria-labelledby="limits-title">
        <h2 id="limits-title" style={{ color: '#1B3B6F' }}>
          Han che da biet (Known limitations)
        </h2>
        <ul>
          <li>AI co the bia so hieu Dieu/Khoan/Luat</li>
          <li>
            Khong co ket noi corpus chinh thuc trong phien ban M1 (du kien
            M2-M3)
          </li>
          <li>Khong tu van vu viec cu the</li>
          <li>Tieng Viet la ngon ngu chinh</li>
          <li>
            Toc do roll back tinh nang voi he thong KV co the den 60 giay
            (Cloudflare KV global propagation)
          </li>
        </ul>
      </section>

      <section aria-labelledby="data-title">
        <h2 id="data-title" style={{ color: '#1B3B6F' }}>
          Du lieu va luu tru
        </h2>
        <ul>
          <li>
            Chat history luu tren trinh duyet (anon) hoac D1 (authed, voi su
            dong y) - 12 thang
          </li>
          <li>
            Audit log: 12 thang D1 + 36 thang R2 (luu tru theo ND 53/2022 Dieu
            27 + Luat ATTT Mang 2018)
          </li>
          <li>
            Du lieu ca nhan duoc xu ly theo ND 13/2023 va Luat Bao ve Du lieu
            Ca nhan 2026
          </li>
          <li>
            Quyen xoa du lieu: gui email{' '}
            <a href="mailto:transparency@asklaw.vn">transparency@asklaw.vn</a>{' '}
            hoac dung /api/me/delete
          </li>
        </ul>
      </section>

      <section aria-labelledby="report-title">
        <h2 id="report-title" style={{ color: '#1B3B6F' }}>
          Bao cao van de
        </h2>
        <ul>
          <li>
            Email:{' '}
            <a href="mailto:transparency@asklaw.vn">transparency@asklaw.vn</a>
          </li>
          <li>
            Form: <a href="/report-issue">/report-issue</a>
          </li>
          <li>
            MoJ inquiry: <a href="mailto:legal@asklaw.vn">legal@asklaw.vn</a>
          </li>
        </ul>
      </section>

      <section aria-labelledby="legal-title">
        <h2 id="legal-title" style={{ color: '#1B3B6F' }}>
          Quy phap ly + Disclaimer
        </h2>
        <ul>
          <li>
            Asklaw KHONG phai cong ty luat. Khong cung cap dich vu phap ly co
            thu phi.
          </li>
          <li>Asklaw KHONG dam bao do chinh xac. AI co the sai.</li>
          <li>
            Voi vu viec ca nhan, lien he luat su co chung chi hanh nghe.
          </li>
        </ul>
      </section>
    </main>
  );
}
